<template>
  <div :class="['loading-container',showLoading && needMask && 'loading-need-mask']"
       @click="maskClicked"
       :style="maskStyle">
    <!--<div class="wxc-loading" :style="{ top: topPosition +'px'}" v-if="showLoading">-->
    <div class="wxc-loading" style="top: 50%; left: 50%; margin-top: -37.5px; margin-left: -37.5px;" v-if="showLoading">
      <div :class="['loading-box',loading.class]" :aria-hidden="true">
        <div style="text-align: center;margin-top: 10px;">
          <img :src="loadingPic || loading.url"
               class="loading-trip-image"
               resize="contain"
               quality="original"
               :hack="isNeedShow"
               ref="img" />
        </div>
        <p v-if="loadingText"
              class="loading-text">{{loadingText}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { GIF, BLACK_GIF } from './type'
// import { BLACK_GIF } from '../../assets/images/loading.gif'
// import img from './img'
// const animation = weex.requireModule('animation')
export default {
  props: {
    show: {
      type: Boolean,
      default: true
    },
    loadingText: {
      type: String,
      default: '加载中'
    },
    loadingPic: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'default'
    },
    interval: {
      type: [Number, String],
      default: 0
    },
    needMask: {
      type: Boolean,
      default: false
    },
    maskStyle: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    showLoading: true,
    tid: 0
  }),
  watch: {
    show () {
      this.setShow()
    }
  },
  computed: {
    loading () {
      let loading = {}
      switch (this.type) {
        case 'trip':
          loading = {
            url: GIF,
            class: 'trip-loading'
          }
          break
        default:
          loading = {
            url: BLACK_GIF,
            class: 'default-loading'
          }
      }
      return loading
    },
    topPosition () {
      return ((document.documentElement.clientHeight || document.body.clientHeight) - 200) / 2
    },
    isNeedShow () {
      if (this.type === 'android' || this.type === 'ios') {
        setTimeout(() => {
          this.androidAnimation()
        }, 50)
      }
      return this.show
    }
  },
  created () {
    this.setShow()
  },
  methods: {
    maskClicked () {
      this.needMask && (this.$emit('wxcLoadingMaskClicked', {}))
    },
    setShow () {
      const { interval, show, showLoading } = this
      const stInterval = parseInt(interval)
      clearTimeout(this.tid)
      if (show) {
        if (showLoading) {
          return
        }
        if (stInterval === 0) {
          this.showLoading = true
        } else {
          this.tid = setTimeout(() => {
            this.showLoading = true
          }, stInterval)
        }
      } else {
        this.showLoading = false
      }
    }
  }
}
</script>

<style scoped>
  .loading-container {
    position: relative;
  }

  .loading-need-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.2);
  }

  .wxc-loading {
    position: fixed;
    left: 287px;
    top: 500px;
    z-index: 9999;
  }

  .loading-box {
    display: flex;
    flex-direction: column;
    align-items: space-around;
    justify-content: center;
    border-radius: 20px;
    width: 90px;
    height: 90px;
    background-color: rgba(0, 0, 0, 0.8);
  }

  .trip-loading {
    background-color: rgba(0, 0, 0, .2);
  }

  .loading-trip-image {
    height: 22px;
    width: 22px;
  }

  .loading-text {
    color: #ffffff;
    font-size: 14px;
    line-height: 16px;
    height: 16px;
    margin-top: 8px;
    text-overflow: ellipsis;
    text-align: center;
  }
</style>
